import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { Utils } from 'formiojs';

@Directive({
  selector: '[appDisplayExternalActions]'
})
export class DisplayExternalActionsDirective implements OnInit {

  constructor(private readonly el: ElementRef) {
  }

  @Input() appDisplayExternalActions: boolean;

  @Input() row;

  @Input() submission;

  ngOnInit(): void {
    this.appDisplayExternalActions ?
      this.appDisplayExternalActions = Utils.evaluate(this.appDisplayExternalActions, {
        row: this.row.data,
        submission: this.submission
      }) : this.appDisplayExternalActions = true;

    this.displayAction(this.appDisplayExternalActions);
  }

  private displayAction(display) {
    if (!display) {
      this.el.nativeElement.style.display = 'none';
    }
  }

}
